import {positionProsts} from "./positionProsts";
export function checkIfAlreadyProsted(ids, commentIds, shopUserId, commentComments, tmpCommunityType) {
    if (shopUserId !== "") {
        $.ajax({
            type: "POST",
            url: "/module/community/ajax.php?action=check_if_already_prosted",
            datatype: "json",
            data: {
                "ajax_call_ids": ids,
                "ajax_call_comment_ids": commentIds,
                "ajax_call_shop_user_id": shopUserId,
                "ajax_call_community_type": tmpCommunityType,
                "ajax_call_community_type_list": communityType
            },
            success: function (output) {
                var forComments = false;
                if (ids === "") {
                    forComments = true;
                }
                positionProsts(output, forComments, commentComments, tmpCommunityType);
            }
        });
    }
}